import { IconInfoCircleOutline } from '@iwoca/icons';
import { AlertBox, Modal } from '@iwoca/orion';

export const CustomersStatusModal = ({
  open,
  close,
}: {
  open: boolean;
  close: () => void;
}) => {
  return (
    <Modal
      closeIcon
      headerBar
      id="modal_id"
      isOpen={open}
      onClose={close}
      title="Spending Limit statuses"
    >
      <CustomerStatus />
    </Modal>
  );
};

const Status = ({
  name,
  description,
  information,
}: {
  name: string;
  description: string;
  information?: string;
}) => {
  return (
    <div className="mx-[-24px] flex gap-l border-b border-b-secondary-90 px-[24px] pb-l pt-s">
      <div className="flex-shrink-0 flex-grow-0 basis-[150px] text-s font-med">
        {name}
      </div>
      <div className="flex flex-col gap-s text-xs font-reg">
        <div>{description}</div>
        {information && (
          <div className="flex gap-xs">
            <IconInfoCircleOutline
              height={16}
              width={16}
              className="flex-shrink-0"
            />
            {information}
          </div>
        )}
      </div>
    </div>
  );
};

const CustomerStatus = () => {
  return (
    <>
      <div className="flex flex-col">
        <Status
          name="Sign-up started"
          description="They haven’t got a Spending Limit yet."
          information="They’ll need to sign-up to apply"
        />
        <Status
          name="Eligible"
          description="They can see their Spending Limit but need to do some final checks before using it."
          information="To finish these checks they need to go to their iwocaPay dashboard"
        />
        <Status
          name="Ready to use"
          description="They can now use their Spending Limit."
          information="Let them know they can use their Spending limit on their next purchase"
        />
        <Status
          name="Ready to refresh"
          description="This amount shown is a customer’s estimated Spending Limit that needs to be confirmed."
          information="They’ll need to hit the refresh button or make a payment"
        />
        <Status
          name="Declined for 30 days"
          description="They aren’t eligible for iwocaPay right now."
          information="They can try again in 30 days"
        />
      </div>
      <AlertBox
        className="mb-xs mt-l flex gap-s text-s font-reg"
        variant="connect"
      >
        <IconInfoCircleOutline
          height={20}
          width={20}
          className="flex-shrink-0"
        />
        <div>
          <a
            href="https://www.coda.io/d/Welcome-to-iwocaPay_dx9e47R5IPf"
            className="font-bold"
          >
            Launch pack:
          </a>{' '}
          Tips and trick on the best ways to encourage buyers at each stage of
          the onboarding journey
        </div>
      </AlertBox>
    </>
  );
};
